<div class="dialog-container">
  <div class="page-header">
    <h2 mat-dialog-title>{{title}}</h2>
    <tpa-button [config]="closeButton"></tpa-button>
  </div>

  <form [formGroup]="form">
    <div class="form">
      <mat-dialog-content>
        <div class="form-container row" fxLayout="wrap">
          @for(control of formControls.controls; track $index){
            <div [ngClass]="[control.class ? control.class : 'col-12']">
              @if (control) {
                <div class="row modal-form-row">
                  @switch (control.type) {
                    @case ('text') {
                      <div class="text-field-outer" [ngClass]="{'with-text-suffix' : convertInput(control).textSuffix}">
                        <tpa-textbox [config]="convertInput(control)"></tpa-textbox>
                      </div>
                    }
                    @case ('number') {
                      <div class="text-field-outer" [ngClass]="{'with-text-suffix' : convertInput(control).textSuffix}">
                        <tpa-textbox [config]="convertInput(control)"></tpa-textbox>
                      </div>
                    }
                    @case ('email') {
                      <div class="text-field-outer" [ngClass]="{'with-text-suffix' : convertInput(control).textSuffix}">
                        <tpa-textbox [config]="convertInput(control)"></tpa-textbox>
                      </div>
                    }
                    @case ($any('passowrd')) {
                      <div class="text-field-outer" [ngClass]="{'with-text-suffix' : convertInput(control).textSuffix}">
                        <tpa-textbox [config]="convertInput(control)"></tpa-textbox>
                      </div>
                    }
                    @case ('contactNumber') {
                      <div class="text-field-outer" [ngClass]="{'with-text-suffix' : convertInput(control).textSuffix}">
                        <tpa-textbox [config]="convertInput(control)"></tpa-textbox>
                      </div>
                    }
                    @case ('dropdown') {
                      <div class="text-field-outer custom-form-control">
                        <tpa-dropdown [config]="convertDropdown(control)"></tpa-dropdown>
                      </div>
                    }
                    @case ('datepicker') {
                      <div class="text-field-outer" [ngClass]="{'with-text-suffix' : convertInput(control).textSuffix}">
                        <tpa-date-picker [config]="convertDatePicker(control)"></tpa-date-picker>
                      </div>
                    }
                    @case ('daterangepicker') {
                      <div class="text-field-outer" [ngClass]="{'with-text-suffix' : convertInput(control).textSuffix}">
                        <tpa-date-range-picker
                        [config]="convertDateRangePicker(control)"></tpa-date-range-picker>
                      </div>
                    }
                    @case ('checkbox') {
                      <div class="text-field-outer" >
                        <tpa-checkbox [config]="convertCheckbox(control)"></tpa-checkbox>
                      </div>
                    }
                    @case ('textarea') {
                      <div class="text-field-outer">
                        <tpa-textarea [config]="convertTextbox(control)"></tpa-textarea>
                      </div>
                    }
                    @case ('radiobutton') {
                      <div class="text-field-outer radio-wrap">
                        <tpa-radio-button [config]="convertRadioButton(control)"></tpa-radio-button>
                      </div>
                    }
                    @case ('slidetoggle') {
                      <div class="text-field-outer">
                        <tpa-slide-toggle [config]="convertSlidetoggle(control)"></tpa-slide-toggle>
                      </div>
                    }
                    @case ('file-upload') {
                      <div class="text-field-outer">
                        <div class="upload-wrapper">
                          <div class="upload-inner">
                            <input type="file" [accept]="acceptFileType || '*/*'" (change)="onFileChange($event,control.control['formControlName'])"/>
                            <button class="btn-upload primary-hover">
                              <img src="./assets/images/ic-upload-white.svg" alt="Icon">
                              {{'COMMON.UPLOAD' | translate}}
                            </button>
                          </div>
                          <p class="file-wrapper" [matTooltip]="getFormControlValue(control.control['formControlName'])?.name" matTooltipClass="custom-tooltip">
                            <span class="file-name-wrapper">
                              {{getFileNameAndExtension(getFormControlValue(control.control['formControlName'])?.name).name}}
                            </span>
                            {{getFileNameAndExtension(getFormControlValue(control.control['formControlName'])?.name).extension}}
                          </p>
                        </div>
                        @if (form.get(control.control['formControlName']).touched && form.get(control.control['formControlName']).invalid) {
                          <mat-error> {{'COMMON.SELECT_FILE' | translate}} </mat-error>
                        }
                      </div>
                    }
                    @case ('multi-file-upload') {
                      <div class="text-field-outer">
                        <app-common-attachment
                          #commonAttachment
                          [singleFileUpload]="false"
                          [isDialog]="true"
                          [title]="'CLAIM.UPLOAD_CLAIMS.FILE_UPLOADING'"
                          [attachmentsControl]="getFormControlOfFile(control.control['formControlName'])"
                          [isClearButtonCallback]="true">
                        </app-common-attachment>
                      </div>
                    }
                  }
                </div>
              }
            </div>
          }
        </div>
      </mat-dialog-content>
    </div>
    <mat-dialog-actions align="end">
      @for(config of displayButtons; track $index) {
        <tpa-button [config]="config"></tpa-button>
      }
    </mat-dialog-actions>
    <div class="button-row">
    </div>
  </form>
</div>
